import React, { FC } from 'react';
import Input, { CurrencyInputProps } from 'react-currency-input-field';

type Props = Omit<CurrencyInputProps, 'onChange' | 'onValueChange'> & {
  label?: string;
  className?: string;
  onChange: (value: string) => void;
  error?: string;
  inputClassName?: string;
};

const AmountInput: FC<Props> = ({
  label,
  className,
  inputClassName = '',
  placeholder,
  error,
  onChange,
  ...props
}) => {
  return (
    <div>
      <label className={`text-[#2E3031] font-medium ${className}`}>
        {label}
        <div className=' mt-1 flex items-center border border-gray-2 rounded-md'>
          <Input
            {...props}
            placeholder={placeholder}
            decimalsLimit={props.decimalsLimit ?? 2}
            onValueChange={(value) => onChange(value ?? '')}
            className={`w-full h-[46px] z-1 relative focus:outline-none  py-3  pl-[14px]  ${inputClassName}`}
          />
          <span className='border rounded-md ml-auto border-[#F2F2F3] p-1 mr-2 bg-[#F2F2F3] text-xs text-gray-6'>
            NGN
          </span>
        </div>
      </label>
      {error && <p className='mt-1 text-[#e60a2b] text-sm'>{error}</p>}
    </div>
  );
};

export default AmountInput;
